export const formatCpfCnpj = (value: string) => {
  if (!value) return "--";
  
  // Remove tudo que não for número
  const numericValue = value.replace(/\D/g, "");

  if (numericValue.length === 11) {
    // Formata como CPF: 000.000.000-00
    return numericValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  } else if (numericValue.length === 14) {
    // Formata como CNPJ: 00.000.000/0000-00
    return numericValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  }

  // Se não for nem CPF nem CNPJ válido, retorna como está
  return value;
};

// Função para formatar CPF (se não estiver formatado)
export const formatCPF = (cpf: string): string => {
  const digits = cpf.replace(/\D/g, '');
  if (digits.length !== 11) return cpf;
  return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

// Função para formatar telefone (considerando 10 ou 11 dígitos)
export const formatTelefone = (telefone: string): string => {
  const digits = telefone.replace(/\D/g, '');
  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  } else if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }
  return telefone;
};